import LegalLayout, { Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" eyebrow="Your data, our duty" lastUpdated="26 Feb 2026">
      <Section heading="1. Who we are">
        Blisson Professional ("Blisson", "we", "us", "our") operates blisson.in and provides premium
        salon-grade hair & skincare products to consumers and salon partners across India. This
        policy explains how we collect, use, and protect your personal data in compliance with the
        Digital Personal Data Protection Act, 2023 (DPDP Act).
      </Section>

      <Section heading="2. What we collect">
        {"• Name, email address, phone number, shipping address — required to fulfil your orders\n• Payment instrument metadata via Razorpay (we never see or store card / UPI credentials)\n• Order history, browsing data, device & cookie information\n• Salon partner details: salon name, owner name, GST (optional), Instagram handle (optional)"}
      </Section>

      <Section heading="3. How we use your data">
        {"• To process orders, deliver products, and provide customer service\n• To send order confirmations and shipping updates via WhatsApp / email / push notifications (only with your consent)\n• To improve our products and tailor offers to you\n• To comply with applicable Indian laws (tax, consumer protection, IT Act)"}
      </Section>

      <Section heading="4. Who we share with">
        We share strictly the minimum data needed with:
        {"\n• Payment gateways (Razorpay) for processing transactions\n• Logistics partners for order fulfilment\n• Google for sign-in (Sign in with Google) — governed by Google's privacy terms\n\nWe will never sell, rent or trade your personal data to any third party."}
      </Section>

      <Section heading="5. Your rights">
        Under the DPDP Act 2023, you have the right to:
        {"\n• Access the personal data we hold about you\n• Correct or update inaccurate data\n• Erase your data (subject to legal retention requirements)\n• Withdraw consent for marketing communications\n\nTo exercise these rights, write to us at theblisson@gmail.com."}
      </Section>

      <Section heading="6. Cookies & analytics">
        We use minimal cookies to keep you signed in and remember your cart. We do not use
        invasive third-party tracking. Push notifications are strictly opt-in.
      </Section>

      <Section heading="7. Security">
        All transmissions are encrypted via HTTPS/TLS. Payments are processed by PCI-DSS compliant
        Razorpay infrastructure. Passwords are not stored — authentication is delegated to Google.
      </Section>

      <Section heading="8. Children">
        Our products are not directed at individuals under 18. We do not knowingly collect data
        from minors.
      </Section>

      <Section heading="9. Updates to this policy">
        We may update this policy from time to time. Material changes will be announced via the
        homepage and/or push notification.
      </Section>

      <Section heading="10. Contact us">
        {"Blisson Professional\n📞 +91 7383899003 (WhatsApp)\n✉ theblisson@gmail.com\n🌐 blisson.in/contact"}
      </Section>
    </LegalLayout>
  );
}
